import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-services-semiconductors',
    templateUrl: 'services-semiconductors.component.html',
    styleUrls: ['../pages.scss', 'services-semiconductors.component.scss'],
})

export class ServicesSemiconductorsComponent {
    activeLanguage = 'german';
    constructor(private ls: LanguageService) {
      ls.getLanguage().subscribe(val => this.activeLanguage = val);
    }
    content = {
        german: `
        <div class="row margin-below">
          <div class="col">
              <h1 class="header">Halbleiterproduktion</h1>
          </div>
        </div>
        <div class="row">
            <div class="text-content col-12">
                <p class="start-indent">
                    <span class="highlight">Technologie Consulting Wolke</span> unterstützt die Halbleiterindustrie
                    nachweislich erfolgreich in der Weiterentwicklung der Chip Produktion und beim Aufbau und Erweiterung
                    der Produktionskapazitäten und – Kompetenzen. Das Leistungsspektrum umfasst insbesondere:
                </p>
                <ul>
                    <li>Den Transfer von Prozesstechnologien vom Entwicklungs- zum Produktionsstandort oder Verlagerung
                    zu neuen Standorten. Dies umfasst z.B. die Erstellung von Anforderungsprofilen an die Produktionsstätten
                    und Mitarbeiter, Festlegung und Erreichen der kritischen Erfolgsparameter, Prozessentwicklung und -transfer
                    vor Ort und Einhalten von Qualitätkontrollvorgaben im vorgesehenen Zeit- und Budgetrahmen.</li>
                    <liDen Aufbau von Produktionslinien von der Projektkonzeption bis zum Start der Serienproduktion.
                    TCW übernimmt Durchführung und Verantwortung von der Kapazitäts- und Linienplanung, über
                    Lieferantenmanagement und Anlagen- und Prozessqualifikation, bis zur Prozessdokumentation,
                    Frei- und Übergabe an die Serienfertigung.</li>
                    <li>Prozessqualifikation und Optimierung der Ausbeute und Produktivität: Risikobewertung mit bewährten
                    Methoden(z.B. durch APQP,  FMEA , SixSigma), Planung und Durchführung von Verbesserungsmaßnahmen,
                    Product Assurance und Prozessstabilität.</li>
                    <li>Mitarbeiter aus- und Weiterbildung in Work Shops und Schulungen z.B. zur Halbleiterprozesstechnik,
                    strukturierte Prozess- und Anlagenoptimierung (Testplanerstellung, Durchführung  und Bewertung)
                     oder Verbesserung der Produktionsverfügbarkeit.</li>
                </ul>
                <p><em>Fragen Sie nach konkreten Projektbeispielen und Referenzen!</em></p>
            </div>
            </div>
            <div class="row">
              <div class="col w-100 image">
                <img src="/assets/services-semiconductors2.jpg">
              </div>
            </div>`,
      english: `
      <div class="row margin-below">
        <div class="col">
            <h1 class="header">Semiconductors</h1>
        </div>
      </div>
  <div class="row">
       <div class="text-content col-12">
              <p class="start-indent">
                  <span class="highlight">Technologie Consulting Wolke</span> provides competent support and training on contamination free manufacturing and clean room operation. für:
              </p>
              <ul>
                  <li>Establish and implement concepts for manufacturing technology in clean environment; planning of media supply and waste treatment; Configuration, specification and selection of suitable production equipment.</li>
                  <li>Local or production wide optimization of wet chemical process steps including tool and process improvement, quality assurance based on client specific product requirements.</li>
                  <li>Training classes and workshops on knowledge transfer in wet and dry cleaning technology and performance control.</li>
                  <li>Risk and hazard analysis according to SEMI S2 or  DIN EN ISO 12100:2010</li>
                  <li>Validation of cleaning processes according to GMP and FDA 21CFR820 standards for medical and pharmaceutical products.</li>
                  <li>Human safety workshops and training on safe handling of chemicals.</li>
              </ul>
              <p><em>Ask for project examples and references!</em></p>
          </div>
          </div>
          <div class="row">
            <div class="col w-100 image">
              <img src="/assets/services-semiconductors2.jpg">
            </div>
          </div>`,
    };

}



// WEBPACK FOOTER //
// ./src/app/components/services-semiconductors/services-semiconductors.component.ts